import { Config } from '../../models/invoices/segments.config.model';
import { ActionList, ActionTypes } from '../../actions/invoices/actions-segments-config';

export interface State {
  errorMessage: string;
  updateRequired: boolean;
  data: Config;
}

export const initialState = {
  errorMessage: '',
  updateRequired: true,
  data: {
    latam_segment_report_enabled: false
  } as Config
};

/* eslint-disable */
export function reducer(state = initialState, action: ActionList) {
  switch (action.type) {
    case ActionTypes.Update:
      return { ...state, updateRequired: true, errorMessage: '' };
    case ActionTypes.Receive:
      return {
        data: {
          offices: action.payload.config.offices,
          latestMonth: action.payload.config.latestMonth,
          latam_segment_report_enabled: action.payload.config.latam_segment_report_enabled
        },
        updateRequired: false,
        errorMessage: action.payload.errorMessage
      };
    case ActionTypes.Reset:
      const resetedState = { ...initialState };
      resetedState.data.latam_segment_report_enabled = state.data.latam_segment_report_enabled;

      return resetedState;
    default:
      return state;
  }
}
